import { Component, inject } from "@angular/core";
import { LoadingService } from "../services/loading/loading";

@Component({
  selector: "app-spinner",
  imports: [],
  standalone: true,
  templateUrl: "./spinner.html",
  styleUrl: "./spinner.scss",
})
export class FullscreenSpinner {
  loadingService = inject(LoadingService);
}
